var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgRocket = function SvgRocket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.94 9.693c3.663-4.272 9.451-7.026 14.527-6.932.289.008.522.25.53.55.117 5.26-2.557 11.267-6.677 15.078-.066 3.635-1.502 7.174-3.977 9.743a.6.6 0 01-.42.181.553.553 0 01-.538-.459l-.598-4.334-.577.536a.528.528 0 01-.744-.022l-6.963-7.227a.577.577 0 01-.022-.773l.516-.599-4.175-.62a.548.548 0 01-.438-.382.578.578 0 01.134-.576c2.51-2.605 5.92-4.095 9.421-4.164zm7.62 3.598a2.65 2.65 0 001.915-.823c1.056-1.095 1.056-2.88 0-3.976a2.642 2.642 0 00-3.831 0c-1.055 1.096-1.055 2.88 0 3.976a2.65 2.65 0 001.915.822zM3.022 28.543c.177-.592 1.769-5.83 2.928-6.988a3.353 3.353 0 014.735 0 3.352 3.352 0 010 4.735c-1.159 1.16-6.396 2.75-6.988 2.928a.54.54 0 01-.675-.675z",
    fill: "#9CA6AD"
  })));
};

export default SvgRocket;